import serviceBase from "./serviceBase";

const yelpService = {
  getUsers: () => serviceBase.get("/api/yelp"),
};

export default yelpService;
